module.exports = "/_next/static/files/5cb5da9731ae8e5bddd8a03df2fe4805.png";